<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span class="esf-action-heading__text">{{tablesTranslations.i18nQuotasPermissions}}</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple"
              (click)="editTicketQuota();$event.stopPropagation();"
              [disabled]="!(selectedLottery.isDraftMode || selectedLottery.isEditMode)"
              [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1;">
  <div class="esf-info-tile__content">
    <h4 class="general" style="padding-top: 0">
      <span i18n="@@tixxSelect.ticketQuota.generalQuota">General quota</span>: {{ currentTicketQuota?.generalQuota ? currentTicketQuota.generalQuota : 0 }}
    </h4>
    <h4 class="active-member" style="padding-top: 0">
      <span i18n="@@tixxSelect.ticketQuota.activeMemberQuota">Active member quota</span>: {{ currentTicketQuota?.activeMemberQuota ? currentTicketQuota.activeMemberQuota : 0 }}
    </h4>
    <table class="esf-table" *ngIf="currentTicketQuota?.customerAttributeConstraintItems?.length">
      <thead class="esf-table__head">
        <tr class="esf-table__row">
          <th class="esf-table__cell esf-table__cell--head">
            <span class="esf-table__cell-inner">{{ tablesTranslations.i18nAttribute }}</span>
          </th>
          <th class="esf-table__cell esf-table__cell--head">
            <span class="esf-table__cell-inner">{{ tablesTranslations.i18nMaxTicketCount }}</span>
          </th>
        </tr>
      </thead>
      <tbody class="esf-table__body">
        <tr class="esf-table__row" *ngFor="let attribute of currentTicketQuota.customerAttributeConstraintItems">
          <td class="esf-table__cell">
            <span class="esf-table__cell-inner">{{ attribute.attributeName }}</span>
          </td>
          <td class="esf-table__cell">
            <span class="esf-table__cell-inner">{{ attribute.quota }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
